import { useMutation } from '@tanstack/react-query';

import { handleApiCall } from '@/api/utils/handleApiCall';
import { useAuth } from '@/context/AuthProvider';

export type SendCommunityInviteEmailsDto = {
  community_id: number;
  shareable_link: string;
  emails: string[];
};

export type ApiResponse_SendCommunityInviteEmails = {
  success: boolean;
  message: string;
  sent_count: number;
};

const METHOD = 'POST';
const ENDPOINT = 'communities/send-invite-emails';

export const useSendCommunityInviteEmails = () => {
  const { session } = useAuth();

  return useMutation({
    mutationFn: async (data: SendCommunityInviteEmailsDto) => {
      const response = await handleApiCall<
        ApiResponse_SendCommunityInviteEmails,
        SendCommunityInviteEmailsDto
      >(
        session,
        METHOD,
        ENDPOINT,
        data
      );
      return response;
    },
  });
};